import { useUserOrganization } from '@modules-deprecated/app/organization'

export const useIsCpaOrganization = () => {
  const { organization, isLoading } = useUserOrganization()

  return {
    isCpaOrganization: !!organization?.ownerUmbrellaId,
    isLoading,
  }
}
